import Configuration from '../config';

export async function createAdminPartnerField(partnerId, values, token) {
  try {
    const response = await fetch(`${Configuration.apiEndPoint}/admin/partners/${partnerId}/fields`, {
      method: 'POST',
      headers: {Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      body: JSON.stringify(values)
    });
    return {status: response.status, json: await response.json()};
  } catch (error) {
    return {status: -1, json: {error: error.message}};
  }
}
